// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './ThemeContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { nl } from 'date-fns/locale';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './context/AuthContext';
import { FeedbackProvider } from './components/common/FeedbackProvider';
import App from './App';
import './index.css';
import { installChunkErrorHandler } from './utils/chunkReload';

// Na een deploy bestaan oude chunks niet meer: dan één keer automatisch herladen
installChunkErrorHandler();

// Prevent mouse-wheel scroll from changing the value of a focused number input.
// Browsers change the value on wheel by default, which is unexpected while scrolling the page.
document.addEventListener(
  'wheel',
  () => {
    const target = document.activeElement;
    if (target && target.tagName === 'INPUT' && target.type === 'number') {
      target.blur();
    }
  },
  { passive: true },
);

// Simple initialization without nested conditions
const rootElement = document.getElementById('root');
if (rootElement && !rootElement._reactRootContainer) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <BrowserRouter>
      <ThemeProvider>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nl}>
          <FeedbackProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </FeedbackProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </BrowserRouter>,
  );
}
